<template>
  <table class="table text-center">
    <tbody>
      <tr v-for="blocks in rowData.blocks" :key="blocks.id">
        <th scope="row">
          <el-tag type="info"
            >{{ $t('common_words.name') }} {{ blocks.name }}</el-tag
          >
        </th>
        <td class="text-left">
          <span v-for="lots in blocks.lots" :key="lots.name">
            <el-tag type="info" style="height: auto; width: 230px">
              {{ $t('common_words.name') }} : {{ lots.name }} <br />
              {{ $t('common_words.area') }}: {{ lots.area }} <br />{{
                $t('common_words.variety')
              }}
              :
              {{
                lots.cropVariety
                  ? lots.cropVariety.name
                  : $t('common_words.no_assignment')
              }}
              <br />{{ $t('common_words.soil_type') }}:
              <span style="text-transform: capitalize">{{
                lots.soil_type_id
                  ? lots.soil_type.name
                  : $t('common_words.none')
              }}</span>
              <br />{{ $t('common_words.population') }}:
              {{ lots.population ? lots.population : $t('common_words.none') }}
            </el-tag>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'lots-info-dialog',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
};
</script>
